// extracted by mini-css-extract-plugin
module.exports = {"background":"_35ugAePC","subtitle":"Wu2-l8Jc","caption":"_2yCFv_xT","hr":"_3AS637ay"};